import urls from './urls'
import Service from '@/utils/fetch'

/**
 * 
 */


export function _getSpaceTableData(data) {
    return Service({
        url:urls.getSpaceTableData,
        data
    })
}

export function _getProductTableData(data) {
    return Service({
        url:urls.getProductTableData,
        data
    })
}

export function _downloadStatistics(data) {
    return Service({
        url:urls.downloadStatistics,
        data,
        responseType: "blob"
    })
}



// WEBPACK FOOTER //
// ./src/api/Statistics/index.js